import { render, staticRenderFns } from "./CourseCardComplete.vue?vue&type=template&id=1906687c&scoped=true"
import script from "./CourseCardComplete.vue?vue&type=script&lang=js"
export * from "./CourseCardComplete.vue?vue&type=script&lang=js"
import style0 from "./CourseCardComplete.vue?vue&type=style&index=0&id=1906687c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906687c",
  null
  
)

export default component.exports